export const localeList = {
    af: "Afrikaans", // Afrikaans
    ar: "العربية", // Arabic
    bd: "Belgisch-Nederlands", // Belgian Dutch
    bf: "Français de Belgique", // Belgian French
    bg: "български", // Bulgarian
    bp: "Português (Brasil)", //Portuguese (Brazil)
    cc: "Cebuano (Cebu)", //Portuguese (Brazil)
    ck: "傳統中文", // Traditional Chinese (Hong Kong)
    cs: "Čeština", // Czech
    ct: "繁體中文", // Traditional Chinese (Taiwan)
    da: "Dansk", // Danish
    de: "Deutsch", // German
    el: "ελληνικα", // Greek
    en: "English", // English
    es: "Español", // Spanish (EU)
    et: "Eesti", //
    fc: "Français canadien", // French Canadian
    fi: "Suomi", // Finnish
    fr: "Français", // French (EU)
    il: "Ilocano", // French (EU)
    gs: "Schweizerdeutsch", // Swiss German
    he: "עברית", // Hebrew
    hg: "Hiligaynon", // Hindi
    hr: "Hrvatski", // Croatian
    hu: "Magyar", // Hungarian
    it: "Italiano", // Italian
    iw: "Svizzero Italiano", // Swiss Italian
    ja: "日本語", // Japanese
    ka: "ქართული", // Georgian
    ko: "한국어", // Korean
    lp: "Español latinoamericano", // Spanish LATAM
    lt: "Lietuviškai", // Lithuanian
    lv: "Latviski", // Latvia
    ms: "Melayu",
    nl: "Nederlands", // Dutch
    no: "Norsk", // Norwegian
    ns: "Sesotho sa Leboa", // Norwegian
    pl: "Polski", // Polish
    pt: "Português", // Portuguese
    ro: "Română", // Romanian
    ru: "Русский", // Russian
    sf: "Français de Suisse", // Swiss French
    sk: "Slovensky", // Slovak
    sl: "Slovenčina", // Slovenian
    sp: "Español-EE.UU", // US Spanish
    sr: "Српски", // Serbian
    st: "Sesotho sa Borwa", // Southern Sotho
    sv: "Svenska", // Swedish
    sy: "Српски (ћирилица)", // Serbian (Cyrillic)
    ta: "", //Tamil
    tl: "Tagalog", // Tagalog
    tn: "Setswana", // Tswana
    tr: "Türkçe", // Turkish
    th: "ไทย",
    xh: "isiXhosa", // Xhosa
    zh: "简体中文", // Simplified Chinese
    zu: "Zulu" // Zulu
}